<template>

  <!-- <h1 v-show="initialProjects">initialProjects</h1>
  <h1 v-show="showStatusOnly">showStatusOnly</h1>
  <h1 v-show="showTopicOnly">showTopicOnly</h1>
  <h1 v-show="showTopicStatus">showTopicStatus</h1>
  {{ projectTopics }}
  {{ projectStatus }} -->
  <div id="grantees-tab">

    <div class="projects-helper">
      <div class="projects-helper__left">

        <form id="support-projects-search" action="https://sg.jb.local/"
              class="form-inline form-search form-search--projects searchform"
              method="get" role="search">

          <input
            v-model="search_input"
            class="form-control onpage-control"
            placeholder="Search Support Projects"
            type="text"
            @change="onSearchInput"/>


        </form>
      </div>

      <div id="support-tags" class="projects-helper__right">
        <nav class="navbar-filter">
          <ul id="do-filters" class="nav-filter">


            <div v-if="statusLoading || topicsLoading" class="lds-spinner-support-small text-center"></div>
            <!-- <p v-if="statusLoading"></p> -->

            <template v-else>
              <DropdownItems :key="statusResult.statuses?.nodes?.name" :clear="true"
                             :options="statusResult.statuses?.nodes" :selected="projectStatus"
                             class="nav-filter__item dropdown do-filter-status supportDropdown" placeholder="Status"
                             v-on:updateOption="statusSelect">
              </DropdownItems>
              <!-- </template> -->

              <!-- <p v-if="topicsLoading"></p> -->

              <!-- <template v-else> -->
              <DropdownItems :key="topicsResult.topics.nodes.name" :clear="true"
                             :options="topicsResult.topics.nodes" :selected="projectTopics"
                             class="nav-filter__item dropdown do-filter-status supportDropdown" placeholder="Topics"
                             v-on:updateOption="topicSelect">
              </DropdownItems>
            </template>


          </ul>
        </nav>
        <!--/Nav Filter-->

        <div id="toggle-grid" class="filter-view">
          <a class="filter-view__link" href="#"><img
            src="https://scattergoodfoundation.org/wp-content/themes/scattergood/img/list-sm-dark.png"></a>
          <a class="filter-view__link is-active" href="#"><img
            src="https://scattergoodfoundation.org/wp-content/themes/scattergood/img/grid-sm-dark.png"></a>
        </div>
        <!--/Filter View-->
      </div>
    </div>
    <!--/PROJECTS HELPER-->

    <div id="support-projects-results" class="publications-results projects-wrap">

      <div class="box-publications">

        <div v-show="initialProjects" class="pre-results searchwp-live-search-results">


          <!-- <p v-if="supportInitialLoading"></p> -->
          <div v-if="supportInitialLoading" class="lds-spinner-support text-center"></div>

          <template v-else>
            <!-- {{supportInitialResult}} -->
            <p v-if="supportInitialResult.projects.nodes.length == 0"
               class="no-results-found text-center position-absolute"
               style="z-index:999; background-color: transparent; width: 100%;">
              No Results Found
            </p>
            <template v-for="(project) in supportInitialResult.projects.nodes" :key="project">

              <div class="project-row">

                <div class="project-main">

                  <a class="project-main__box grantee-new" v-bind:href="project.link">

                    <template v-for="(size) in project.moduleSystem.featuredImage.mediaDetails.sizes" :key="size">

                      <template v-if="size.name == 'support-card' ">
                        <div :style="{ 'background-image': bgImage(size.sourceUrl) }"
                             class="grantee__img"></div>
                      </template>

                    </template>

                    <h2>{{ project.title }}</h2>

                    <div class="project-main__tags">
                      <span class="project-main__tag">{{ project.moduleSystem?.status?.name }}
                        <!-- STATUS tag ( active, complete, ongoing etc ) -->
                      </span>
                      <span class="project-main__tag">
                        <!-- Project Tag ( Awards, XYZ ) -->
                      </span>
                    </div>
                  </a>


                  <div class="project-main__content">
                    <h6>Innovation</h6>
                    <p></p>
                    <p>{{ project.moduleSystem.projectsHeroDescription }}</p>
                    <p></p>
                  </div>


                </div>


                <div class="project-grantee">

                  <!-- GRANTEE CHANGED -->

                  <h6>Grantee</h6>
                  <template
                    v-for="(size) in (project.moduleSystem?.grantee?.organizations?.organizationLogo?.mediaDetails?.sizes || [])"
                    :key="size">
                    <img v-if="size.name == 'partner-logo'" v-bind:src="imgageUrl(size.sourceUrl)">
                  </template>

                  <template v-if="project.moduleSystem?.grantee?.organizations?.granteeWebsite">

                    <h2><a target="_blank" v-bind:href="project.moduleSystem?.grantee?.organizations?.granteeWebsite">{{
                        project.moduleSystem.grantee.name
                      }}</a></h2>

                  </template>

                  <template v-else>
                    <h2><a href="#">{{ project.moduleSystem?.grantee?.name }}</a></h2>
                  </template>


                </div>

              </div>

            </template>

          </template>

        </div>


        <div v-show="showStatusOnly" class="pre-results searchwp-live-search-results">

          <!-- <p v-if="statusOnlyLoading"></p> -->
          <div v-if="statusOnlyLoading" class="lds-spinner-support text-center"></div>

          <template v-else>
            <!-- {{supportInitialResult}} -->
            <p v-if="statusOnlyResult.projects.nodes.length == 0"
               class="no-results-found text-center position-absolute"
               style="z-index:999; background-color: transparent; width: 100%;">
              No Results Found
            </p>
            <template v-for="(project) in statusOnlyResult.projects.nodes" :key="project">

              <div class="project-row">

                <div class="project-main">

                  <a class="project-main__box grantee-new" v-bind:href="project.link">

                    <template v-for="(size) in project.moduleSystem.featuredImage.mediaDetails.sizes" :key="size">

                      <template v-if="size.name == 'support-card' ">
                        <div :style="{ 'background-image': bgImage(size.sourceUrl) }"
                             class="grantee__img"></div>
                      </template>

                    </template>

                    <h2>{{ project.title }}</h2>

                    <div class="project-main__tags">
                      <span class="project-main__tag">{{ project.moduleSystem?.status?.name }}
                        <!-- STATUS tag ( active, complete, ongoing etc ) -->
                      </span>
                      <span class="project-main__tag">
                        <!-- Project Tag ( Awards, XYZ ) -->
                      </span>
                    </div>
                  </a>


                  <div class="project-main__content">
                    <h6>Innovation</h6>
                    <p></p>
                    <p>{{ project.moduleSystem.projectsHeroDescription }}</p>
                    <p></p>
                  </div>


                </div>


                <div class="project-grantee">

                  <!-- GRANTEE CHANGED -->

                  <h6>Grantee</h6>
                  <template
                    v-for="(size) in (project.moduleSystem.grantee.organizations?.organizationLogo?.mediaDetails?.sizes || [])"
                    :key="size">
                    <img v-if="size.name == 'partner-logo'" v-bind:src="imgageUrl(size.sourceUrl)">
                  </template>

                  <template v-if="project.moduleSystem.grantee.organizations.granteeWebsite">

                    <h2><a target="_blank" v-bind:href="project.moduleSystem.grantee.organizations.granteeWebsite">{{
                        project.moduleSystem.grantee.name
                      }}</a></h2>

                  </template>

                  <template v-else>
                    <h2><a href="#">{{ project.moduleSystem.grantee.name }}</a></h2>
                  </template>


                </div>

              </div>

            </template>

          </template>

        </div>

        <div v-show="showTopicOnly" class="pre-results searchwp-live-search-results">

          <!-- <p v-if="topicOnlyLoading"></p> -->
          <div v-if="topicOnlyLoading" class="lds-spinner-support text-center"></div>

          <template v-else>
            <!-- {{supportInitialResult}} -->
            <p v-if="topicOnlyResult.projects.nodes.length == 0"
               class="no-results-found text-center position-absolute"
               style="z-index:999; background-color: transparent; width: 100%;">
              No Results Found
            </p>
            <template v-for="(project) in topicOnlyResult.projects.nodes" :key="project">

              <div class="project-row">

                <div class="project-main">

                  <a class="project-main__box grantee-new" v-bind:href="project.link">

                    <template v-for="(size) in project.moduleSystem.featuredImage.mediaDetails.sizes" :key="size">

                      <template v-if="size.name == 'support-card' ">
                        <div :style="{ 'background-image': bgImage(size.sourceUrl) }"
                             class="grantee__img"></div>
                      </template>

                    </template>

                    <h2>{{ project.title }}</h2>

                    <div class="project-main__tags">
                      <span class="project-main__tag">{{ project.moduleSystem?.status?.name }}
                        <!-- STATUS tag ( active, complete, ongoing etc ) -->
                      </span>
                      <span class="project-main__tag">
                        <!-- Project Tag ( Awards, XYZ ) -->
                      </span>
                    </div>
                  </a>


                  <div class="project-main__content">
                    <h6>Innovation</h6>
                    <p></p>
                    <p>{{ project.moduleSystem.projectsHeroDescription }}</p>
                    <p></p>
                  </div>


                </div>


                <div class="project-grantee">

                  <!-- GRANTEE CHANGED -->

                  <h6>Grantee</h6>
                  <template
                    v-for="(size) in (project.moduleSystem.grantee.organizations?.organizationLogo?.mediaDetails?.sizes || [])"
                    :key="size">
                    <img v-if="size.name == 'partner-logo'" v-bind:src="imgageUrl(size.sourceUrl)">
                  </template>

                  <template v-if="project.moduleSystem.grantee.organizations.granteeWebsite">

                    <h2><a target="_blank" v-bind:href="project.moduleSystem.grantee.organizations.granteeWebsite">{{
                        project.moduleSystem.grantee.name
                      }}</a></h2>

                  </template>

                  <template v-else>
                    <h2><a href="#">{{ project.moduleSystem.grantee.name }}</a></h2>
                  </template>


                </div>

              </div>

            </template>

          </template>

        </div>

        <div v-show="showTopicStatus" class="pre-results searchwp-live-search-results">

          <!-- <p v-if="topicStatusLoading"></p> -->
          <div v-if="topicStatusLoading" class="lds-spinner-support text-center"></div>

          <template v-else>
            <!-- {{supportInitialResult}} -->
            <p v-if="topicStatusResult.projects.nodes.length == 0"
               class="no-results-found text-center position-absolute"
               style="z-index:999; background-color: transparent; width: 100%;">
              No Results Found
            </p>
            <template v-for="(project) in topicStatusResult.projects.nodes" :key="project">

              <div class="project-row">

                <div class="project-main">

                  <a class="project-main__box grantee-new" v-bind:href="project.link">

                    <template v-for="(size) in project.moduleSystem.featuredImage.mediaDetails.sizes" :key="size">

                      <template v-if="size.name == 'support-card' ">
                        <div :style="{ 'background-image': bgImage(size.sourceUrl) }"
                             class="grantee__img"></div>
                      </template>

                    </template>

                    <h2>{{ project.title }}</h2>

                    <div class="project-main__tags">
                      <span class="project-main__tag">{{ project.moduleSystem?.status?.name }}
                        <!-- STATUS tag ( active, complete, ongoing etc ) -->
                      </span>
                      <span class="project-main__tag">
                        <!-- Project Tag ( Awards, XYZ ) -->
                      </span>
                    </div>
                  </a>


                  <div class="project-main__content">
                    <h6>Innovation</h6>
                    <p></p>
                    <p>{{ project.moduleSystem.projectsHeroDescription }}</p>
                    <p></p>
                  </div>


                </div>


                <div class="project-grantee">

                  <!-- GRANTEE CHANGED -->

                  <h6>Grantee</h6>
                  <template
                    v-for="(size) in (project.moduleSystem.grantee.organizations?.organizationLogo?.mediaDetails?.sizes || [])"
                    :key="size">
                    <img v-if="size.name == 'partner-logo'" v-bind:src="imgageUrl(size.sourceUrl)">
                  </template>

                  <template v-if="project?.moduleSystem?.grantee?.organizations?.granteeWebsite">

                    <h2><a target="_blank" v-bind:href="project?.moduleSystem?.grantee?.organizations?.granteeWebsite">{{
                        project?.moduleSystem?.grantee?.name
                      }}</a></h2>

                  </template>

                  <template v-else>
                    <h2><a href="#">{{ project?.moduleSystem?.grantee?.name }}</a></h2>
                  </template>


                </div>

              </div>

            </template>

          </template>

        </div>

      </div>
      <!--/Box Publications-->

      <!-- <button class="btn btn-md btn-white btn-center load-support-projects">Load More</button> -->
      <!--/Load More-->


    </div>


  </div>

</template>

<script setup>

import {ref} from "vue";
import {useQuery} from "@vue/apollo-composable";
// import { empty } from "@apollo/client/core";
import {useDebouncedRef} from './debouncedRef'


// :::::::::::::::::::::: Import filter query files ::::::::::::::::::::::
import topicsTaxonomy from '../graphql/filterOptions/topicsTaxonomy.gql'
import statusTaxonomy from '../graphql/filterOptions/statusTaxonomy.gql'


// :::::::::::::::::::::: Import results query files ::::::::::::::::::::::
//initial
import supportInitialResultsQuery from '../graphql/results/supportInitialResults.gql'

//Status Only
import supportStatusOnlyQuery from '../graphql/results/supportStatusOnly.gql'

//Status Only
import supportTopicOnlyQuery from '../graphql/results/supportTopicOnly.gql'

//Status Only
import supportTopicStatusQuery from '../graphql/results/supportTopicStatus.gql'


//import components
import DropdownItems from '../components/DropdownItems.vue';

console.log('Feature Category:', window.featured_project_category);

//hard coded values
let projectType = ref('8') // Support Project term Taxonomny ID
let projectCategory = ref(String(window.featured_project_category || '46')) //Community Fund for Wellness
let search_input = useDebouncedRef('');

let projectTopics = ref('');
let projectStatus = ref('');

let initialProjects = ref(true)
let showTopicOnly = ref(false)
let showStatusOnly = ref(false)
let showTopicStatus = ref(false)

const topicSelect = (payload) => {
  if (payload.termTaxonomyId) {

    projectTopics.value = payload.termTaxonomyId.toString()
    optionsCheck()
    console.log(projectTopics)
    console.log('payload=')
    console.log(payload)

  } else {
    console.log('notaxID');
    projectTopics.value = '';
    optionsCheck()
    console.log('payload=')
    console.log(payload)
  }
}

const statusSelect = (payload) => {
  if (payload.termTaxonomyId) {

    projectStatus.value = payload.termTaxonomyId.toString()
    optionsCheck()
    console.log(projectStatus)
    console.log('payload=')
    console.log(payload)

  } else {
    console.log('notaxID');
    projectStatus.value = '';
    optionsCheck()
    console.log(projectStatus)
    console.log('payload=')
    console.log(payload)
  }
}

const imgageUrl = (imageSrc) => {
  return imageSrc;
}


const bgImage = (image) => {

  // console.log( image )
  return `url("${image}")`;
}

// const onClearFilters = () => {

//     projectServices.value = ''
//     optionsCheck()
//     console.log( projectServices.value )

// }

const optionsCheck = () => {

  let topic = projectTopics.value.length !== 0 ? true : false;
  let status = projectStatus.value.length !== 0 ? true : false;


  if (topic == true && status == true) {

    console.log('status and topic')
    initialProjects.value = false
    showTopicOnly.value = false
    showStatusOnly.value = false
    showTopicStatus.value = true

  } else if (topic == true && status == false) {

    console.log('topic only')
    initialProjects.value = false
    showTopicOnly.value = true
    showStatusOnly.value = false
    showTopicStatus.value = false

  } else if (topic == false && status == true) {

    console.log('status only')
    initialProjects.value = false
    showTopicOnly.value = false
    showStatusOnly.value = true
    showTopicStatus.value = false

  } else if (topic == false && status == false) {

    console.log('show initial')
    initialProjects.value = true
    showTopicOnly.value = false
    showStatusOnly.value = false
    showTopicStatus.value = false

  }


}


const onSearchInput = (e) => {
  this.search_input.value = e.target.value;
}
const onTaxInput = (e) => {
  this.tax_input.value = e.target.value;
}


//  :::::::::::::::::::::: Import filter queries ::::::::::::::::::::::
/**
 * Get Project Topics for Filters
 **/

const {
  result: topicsResult,
  loading: topicsLoading,
  error: topicsError,
  options: topicsOptions,
  variables: topicsVariables
} = useQuery(topicsTaxonomy);


/**
 * Get Project Status for Filters
 **/

const {
  result: statusResult,
  loading: statusLoading,
  error: statusError,
  options: statusOptions,
  variables: statusVariables
} = useQuery(statusTaxonomy);

//   :::::::::::::::::::::: Import Results queries ::::::::::::::::::::::
/**
 * Get initial projects result
 **/
const {
  result: supportInitialResult,
  loading: supportInitialLoading,
  error: supportInitialError,
  options: supportInitialOptions,
  variables: supportInitialVariables,
  refetch: supportInitialRefetch
} = useQuery(supportInitialResultsQuery, {
  projecttype: projectType,
  projectcategory: projectCategory,
  search_input: search_input
});


//service only
/**
 * Get ServiceOnlyResult
 **/



// topic alone
/**
 * Get Topic Only
 **/
const {
  result: topicOnlyResult,
  loading: topicOnlyLoading,
  error: topicOnlyError,
  options: topicOnlyOptions,
  variables: topicOnlyVariables,
  refetch: topicOnlyRefetch
} = useQuery(supportTopicOnlyQuery, {
  projecttype: projectType,
  projectcategory: projectCategory,
  topic: projectTopics,
  search_input: search_input
});


// topic status
/**
 * Get Topic Status
 **/
const {
  result: topicStatusResult,
  loading: topicStatusLoading,
  error: topicStatusError,
  options: topicStatusOptions,
  variables: topicStatusVariables,
  refetch: topicStatusRefetch
} = useQuery(supportTopicStatusQuery, {
  projecttype: projectType,
  projectcategory: projectCategory,
  topic: projectTopics,
  status: projectStatus,
  search_input: search_input
});


// status alone
/**
 * Get Status Alone
 **/
const {
  result: statusOnlyResult,
  loading: statusOnlyLoading,
  error: statusOnlyError,
  options: statusOnlyOptions,
  variables: statusOnlyVariables,
  refetch: statusOnlyRefetch
} = useQuery(supportStatusOnlyQuery, {
  projecttype: projectType,
  projectcategory: projectCategory,
  status: projectStatus,
  search_input: search_input
});


</script>
<style>
#app .supportDropdown .caret-vue {
  color: #00a98e;
}
</style>



















